<template>
  <div class="home">
    <img src="./../assets/img/index.png" id="bg">
    <div class="kong"></div>
    <img src="./../assets/img/logo.png" class="logo">
    <div class="type">
      <ul class="ul">
        <router-link to="/intro" tag="li">
          <div class="circle valign">
            <img src="./../assets/img/icon1.png" alt="">
          </div>
          <p>公司介绍</p>  
        </router-link>
        <li @click="show">
          <div class="circle valign">
            <img src="./../assets/img/icon2.png" alt="">
          </div>
          <p>公司产品</p>  
        </li>
        <router-link to="/case" tag="li">
          <div class="circle valign">
            <img src="./../assets/img/icon3.png" alt="">
          </div>
          <p>客户案例</p>  
        </router-link>
        <router-link to="/constract" tag="li">
          <div class="circle valign">
            <img src="./../assets/img/icon4.png" alt="">
          </div>
          <p>联系我们</p>  
        </router-link>
      </ul>
      <div class="type_detail" v-show="isShow">
        <ul>
          <router-link to="/ishow" tag="li">i展示</router-link>
          <router-link to="/qhudong" tag="li">Q互动</router-link>
          <router-link to="/sign" tag="li">智能签到</router-link>
          <router-link to="/live" tag="li">直播相册</router-link>
        </ul>
      </div>
      <p class="txt">声速响应 • 精品交付</p>
    </div>
  </div>
</template>

<style scoped>
.home{width:100%;height:100%;}
.home #bg{width:100%;position: absolute;left:0;top:0;z-index:-2;}
.home .kong{height:.18rem;width:100%;}
.home .logo{width:2.2rem;}
.type{width:100%;position: relative;}
.type ul.ul{margin-top:.1rem;}
.type ul.ul li{display: flex;margin-left:.97rem;}
.type ul.ul li:nth-child(2){margin-top:.46rem;margin-left:1.46rem;}
.type ul.ul li:nth-child(3){margin-top:.56rem;margin-left:1.3rem;}
.type ul.ul li:nth-child(4){margin-top:.22rem;margin-left:.7rem;}
.type ul.ul li .circle{width:.54rem;height:.54rem;border-radius: 50%;border:.03rem solid #0064d2;background:#fff;}
.type ul.ul li p{font:700 .2rem/.54rem "宋体";color:#212121;margin-left:.05rem;}
.type .type_detail{width:1.4rem;height:1.12rem;position: absolute;left:2.12rem;top:.76rem;border:.01rem solid #004592;border-left:0;}
.type .type_detail ul li{float:left;width:.48rem;height:.48rem;border-radius: 50%;border:.02rem solid #116ed3;text-align: center;font:700 .08rem/.44rem "宋体";color:#000;background:#fff;}
.type .type_detail ul li:nth-child(1){margin-top:-.26rem;}
.type .type_detail ul li:nth-child(2){margin-left:.2rem;margin-top:-.26rem;}
.type .type_detail ul li:nth-child(3){margin-top:.6rem;}
.type .type_detail ul li:nth-child(4){margin-left:.2rem;margin-top:.6rem;}
.type .txt{text-align: center;font:700 .22rem/.3rem "Helvetica";color:#000;margin-top:.52rem;color:#0064d2;font-family: "Helvetica"}
</style>

<script>
import $ from 'jquery';
export default {
  data(){
    return {
      isShow:false
    }
  },
  methods:{
    show(){
      this.isShow = !this.isShow;
    }
  }
}

</script>


